// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__DwK57","resendInfoText":"OnGoingPaymentBox_resendInfoText__1VGCL"};